<template>
  <div>
    hello
  </div>
</template>

<script>
export default {
  mounted() {
    console.log("clerar");
    sessionStorage.removeItem("10008_yc_token");
    localStorage.removeItem("yc_token");
    // router.replace({name:'Login'})
  }
};
</script>
